
interface FinalConversionProps {
  onRegister: () => void;
  onBookSession: () => void;
  onDownload: () => void;
  onDinnerRequest: () => void;
  onBoothMeeting: () => void;
}

export default function FinalConversion({ 
  onRegister, 
  onBookSession, 
  onDownload, 
  onDinnerRequest,
  onBoothMeeting 
}: FinalConversionProps) {
  return (
    <section className="py-28 bg-gradient-to-br from-gray-900 via-[#1e3a8a] to-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Main Headline */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            AI Leadership Requires More Than Inspiration.<br />
            <span className="text-[#60a5fa]">It Requires Execution.</span>
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
            Join Covasant at IDC Middle East CIO Summit 2026 and transform your AI strategy from vision to measurable enterprise value.
          </p>
        </div>

        {/* CTA Grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {/* Primary CTA 1 */}
          <button
            onClick={onRegister}
            className="bg-white text-gray-900 px-8 py-6 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-2xl flex items-center justify-between group cursor-pointer whitespace-nowrap"
          >
            <div className="text-left">
              <div className="text-sm text-gray-500 mb-1">Step 1</div>
              <div>Register & Meet Covasant</div>
            </div>
            <i className="ri-arrow-right-line text-2xl group-hover:translate-x-2 transition-transform"></i>
          </button>

          {/* Primary CTA 2 */}
          <button
            onClick={onBookSession}
            className="bg-[#3b82f6] text-white px-8 py-6 rounded-xl font-bold text-lg hover:bg-[#2563eb] transition-all transform hover:scale-105 shadow-2xl flex items-center justify-between group cursor-pointer whitespace-nowrap"
          >
            <div className="text-left">
              <div className="text-sm text-white/70 mb-1">Step 2</div>
              <div>Book Executive Roadmap Session</div>
            </div>
            <i className="ri-calendar-check-line text-2xl group-hover:scale-110 transition-transform"></i>
          </button>

          {/* Secondary CTA 1 */}
          <button
            onClick={onDownload}
            className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-6 rounded-xl font-bold text-lg hover:bg-white/20 transition-all flex items-center justify-between group cursor-pointer whitespace-nowrap"
          >
            <div className="text-left">
              <div className="text-sm text-white/70 mb-1">Resources</div>
              <div>Download Strategic Brief</div>
            </div>
            <i className="ri-download-cloud-line text-2xl group-hover:translate-y-1 transition-transform"></i>
          </button>

          {/* Secondary CTA 2 */}
          <button
            onClick={onDinnerRequest}
            className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-6 rounded-xl font-bold text-lg hover:bg-white/20 transition-all flex items-center justify-between group cursor-pointer whitespace-nowrap"
          >
            <div className="text-left">
              <div className="text-sm text-white/70 mb-1">Exclusive</div>
              <div>Request CIO Dinner Invitation</div>
            </div>
            <i className="ri-restaurant-line text-2xl group-hover:scale-110 transition-transform"></i>
          </button>
        </div>

        {/* Booth CTA */}
        <div className="text-center">
          <button
            onClick={onBoothMeeting}
            className="inline-flex items-center gap-3 bg-gradient-to-r from-[#1e40af] to-[#60a5fa] text-white px-10 py-5 rounded-full font-bold text-lg hover:shadow-2xl transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-map-pin-line text-2xl"></i>
            Visit Us at Booth TFG 28
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>

        {/* Event Details Footer */}
        <div className="mt-16 pt-12 border-t border-white/20 flex flex-wrap items-center justify-center gap-8 text-white/60">
          <div className="flex items-center gap-2">
            <i className="ri-calendar-line"></i>
            <span>11–12 February 2026</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-map-pin-line"></i>
            <span>Atlantis, The Palm · Dubai</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-building-line"></i>
            <span>Booth TFG 28</span>
          </div>
        </div>
      </div>
    </section>
  );
}
